module.exports = __webpack_public_path__ + "img/3.fbd55c1f.png";